<template>
  <div style="overflow-y: auto" 
    v-if="isPermittedAll([
        'UsersGetAll'
    ]) && isMobile">
      <v-expansion-panels multiple v-model="expanded" class="custom-expansion">  
        <v-expansion-panel
          v-for="(user, i) in mobileFilteredUsers"
        >
          <v-expansion-panel-header>
            <div  v-if="expanded.includes(i) === false">
              <div class="mb-2">
                <b >{{ user.UserGivenName }}</b>
              </div>
              <div>{{ user.UserEmailAddress }}</div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div>
              <div>
                <b>Name</b>
                <p>{{ user.UserGivenName }}</p> 
              </div>
              <div>
                <b>Location</b>
                  <p>{{ user.UserLocation }}</p> 
              </div>
              <div>
                <b>Phone</b>
                <p>{{ user.UserPhoneNumber }}</p> 
              </div>
              <div>
                <b>Email Address</b>
                <p>{{ user.UserEmailAddress }}</p> 
              </div>    
              <div class="d-flex">
                <div>
                  <b>Notes</b>
                  <p>{{ user.UserNotes }}</p> 
                </div>
                <v-btn
                  @click="isPermittedAll([
                    'UsersGetByID'
                  ]) && openUser(user.UserID)"
                  type="button"
                  color="primary"
                  outlined
                  class="ml-auto align-self-center">
                  View
                </v-btn>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  <v-data-table
    v-else-if="isPermittedAll([
      'UsersGetAll'
    ])"
    id="users-table"
    class="page-table"
    mobile-breakpoint="-1"
    :headers="userFields"
    :items="users"
    item-key="UserID"
    dense
    disable-pagination
    hide-default-footer
    fixed-header
    :options="{
      sortBy: ['UserGivenName'],
      rowsPerPage: -1,
    }">
    <template
      v-slot:item="row">
      <tr
        class="pointer"
        :class="{
          'hidden-table-row': row.item.UserIsDeleted
        }"
        @click="isPermittedAll([
          'UsersGetByID'
        ]) && openUser(row.item.UserID)">
        <td>{{row.item.UserGivenName}}</td>
        <td>{{row.item.UserLocation}}</td>
        <td>{{row.item.UserPhoneNumber}}</td>
        <td>{{row.item.UserEmailAddress}}</td>
        <td>{{row.item.UserNotes}}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'UsersTable',
  props: ['users'],
  data() {
    return {
      expanded: [],
      userFields: [
        {
          text: 'Name',
          value: 'UserGivenName',
        },
        {
          text: 'Location',
          value: 'UserLocation',
        },
        {
          text: 'Phone',
          value: 'UserPhoneNumber',
        },
        {
          text: 'Email Address',
          value: 'UserEmailAddress',
        },
        {
          text: 'Notes',
          value: 'UserNotes',
        },
      ],
    };
  },
  methods: {
    openUser(UserID) {
      this.getUser(UserID);
      this.$router.push({ name: 'UserFormPage', params: { UserID } });
    },
  },
computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    mobileFilteredUsers() {
      return this.users.filter(x => x.UserIsDeleted === false)
        .sort((a, b) => a.UserGivenName.localeCompare(b.UserGivenName));
    }
  },
  created() {
    this.$store.dispatch('getUsers');
  },
};
</script>
